<template>
    <ul class="common-map-component-tool-wrap tool-bar-wrap clearFloat tool-bar-block">
        <li
                v-if="showMove || (showTool || []).includes('move')"
                :class="{'active': currentToolType === moveItem.type}"
                :title="moveItem.label"
                @click="handleDrawSwitch(moveItem)"
        >
            <ev-iconFont :icon="moveItem.icon"></ev-iconFont>
        </li>
        <li
                v-for="item in toolList"
                :key="item.type"
                :class="{'active': item.type === currentToolType, 'tip': true, 'db-complete': ['line', 'polygon', 'rectangle', 'circular'].includes(item.type)}"
                :title="item.label"
                @click="handleDrawSwitch(item)"
        >
            <ev-iconFont :icon="item.icon"></ev-iconFont>
        </li>
    </ul>
</template>

<script>
    export default JBoot({
        name: "commonMapTool",

        registryName: "common-map-tool",

        props: {
            showTool: {
                type: Array,
                default() {
                    return [];
                }
            },

            showMove: {
                type: Boolean,
                default() {
                    return false;
                }
            },

            drawColor: {
                type: String,
                default() {
                    return "red";
                }
            },

            markerIcon: {
                type: String,
                default() {
                    return "other";
                }
            },

            model: Array
        },

        inject: {
            commonMapInstance: {
                type: Object,
                default() {
                    return {};
                }
            }
        },

        data() {
            return {
                currentToolType: undefined,
                moveItem: {label: "移动", type: "move", icon: "icon-hf_xiaoshou"},
                mapIsReady: false
            };
        },

        computed: {
            toolList() {
                let filterArr = this.showTool || [];

                return [
                    {label: "线段", type: "line", icon: "icon-xianduan"},
                    // {label: "圆形", type: "circular", icon: "icon-yuanxingkuang"},
                    // {label: "矩形", type: "rectangle", icon: "icon-zhengfangxing1"},
                    {label: "多边形", type: "polygon", icon: "icon-ditu-duobianxing"},
                    {label: "标注点", type: "marker", icon: "icon-ziyuan1"}
                ].filter(item =>
                    filterArr.length > 0 ? filterArr.includes(item.type) : true
                );
            }
        },

        mounted (){
            this.$busListener('map.bd.ready', () => {
                this.mapIsReady = true;

                this.model && this.model.length > 0 && !this.isEchoHandleEnd && this.model.forEach(this.handleEcho);
            });
        },

        methods: {
            handleDrawComplete(result, type) {
                this.$emit("complete", result.map(item => {
                    return {
                        options: Object.assign({}, this.currentDrawItem || {}, {
                            drawColor: this.drawColor,
                            markerIcon: this.markerIcon,
                            type
                        }),
                        value: item
                    }
                }));
            },

            handleDrawSwitch(item) {
                this.currentDrawItem = item;

                this.currentToolType = item.type;

                switch (this.currentToolType) {
                    case "line":
                        this.commonMapInstance._drawLine(
                            this.drawColor,
                            this.handleDrawComplete
                        );
                        break;
                    case "circular":
                        this.commonMapInstance._drawCircular(
                            this.drawColor,
                            this.handleDrawComplete
                        );
                        break;
                    case "rectangle":
                        this.commonMapInstance._drawRectangle(
                            this.drawColor,
                            this.handleDrawComplete
                        );
                        break;
                    case "polygon":
                        this.commonMapInstance._drawPolygon(
                            this.drawColor,
                            this.handleDrawComplete
                        );
                        break;
                    case "marker":
                        this.commonMapInstance._drawMarker(
                            this.markerIcon,
                            this.handleDrawComplete
                        );
                        break;
                    default:
                    // this.commonMapInstance._cancelDraw();
                }
            },

            handleEcho({options, value} = {}) {
                this.isEchoHandleEnd = true;

                let type = options.type;

                switch (type) {
                    case "polygon":
                        this.commonMapInstance._drawPolygon(
                            options.drawColor || "red",
                            this.handleDrawComplete,
                            value
                        );
                        break;
                    case "marker":
                        this.commonMapInstance._drawMarker(
                            options.markerIcon,
                            this.handleDrawComplete,
                            value
                        );
                        break;
                    case "line":
                        this.commonMapInstance._drawLine(
                            options.drawColor,
                            this.handleDrawComplete,
                            value
                        );
                        break;
                    case "rectangle":
                        this.commonMapInstance._drawRectangle(
                            options.drawColor,
                            this.handleDrawComplete,
                            [ value ]
                        );
                        break;
                    case "circular":
                        this.commonMapInstance._drawCircular(
                            options.drawColor,
                            this.handleDrawComplete,
                            value
                        );
                        break;
                }
            }
        },

        watch: {
            showTool: {
                immediate: true,
                handler(val) {
                    if (!val || val.length === 0) {
                        if (this.showMove) {
                            this.currentToolType = "move";
                        }
                    } else {
                        if (val.includes("move")) {
                            this.currentToolType = "move";
                        } else {
                            this.currentToolType = val[0];
                        }
                    }
                }
            },

            model: {
                immediate: true,
                deep: true,
                handler (val){
                    this.isEchoHandleEnd = false;

                    if(val && val.length > 0){
                        this.mapIsReady && !this.isEchoHandleEnd && val.forEach(this.handleEcho);
                    }
                }
            }
        }
    }).build();
</script>

<style lang="scss">
    .common-map-component-tool-wrap {
        display: inline-block;
        /*overflow: hidden;*/
        box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
        border-radius: 4px;
        background-color: #ffffff;
        /*border: 1px solid #cf1322;*/
        & > li {
            position: relative;
            cursor: pointer;
            float: left;
            width: 30px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #cf1322;
            font-weight: bold;
            background-color: #fff;
            border: 1px solid #cf1322;
            & .ev-system-mask-container {
                background-color: #cccccc;

                & > .ev-system-mask-spinner {
                    margin-top: 5px !important;
                }
            }

            &:not(:last-child) {
                /*border-right: 1px solid #ccc;*/
            }
            &:first-child{
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
            }
            &:last-child{
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
            }

            &:hover,
            &.active {
                opacity: 1;
                color: #fff;
                background-color: #cf1322;
            }

            &:before,
            &:after {
                transition: opacity, transform 0.3s;
            }

            &.tip {
                position: relative;

                &:before,
                &:after {
                    visibility: hidden;
                    opacity: 0;
                }

                &:before {
                    position: absolute;
                    content: "";
                    top: calc(100% + 3px);
                    border-top: 0;
                    border-left: 7px solid transparent;
                    border-right: 7px solid transparent;
                    border-bottom: 7px solid #1d1d1d;
                }

                &:after {
                    position: absolute;
                    font-size: 12px;
                    content: "鼠标右键绘制层,可进行删除操作";
                    line-height: 12px;
                    font-weight: 400;
                    white-space: nowrap;
                    top: calc(100% + 10px);
                    left: -150px;
                    background-color: #1d1d1d;
                    color: #ffffff;
                    padding: 5px;
                    border-radius: 4px;
                }
                &.db-complete:after{
                    content: '鼠标右键绘制层,可进行删除操作,双击完成绘制';
                    left: -225px;
                }
            }

            &.active {
                &:before,
                &:after {
                    visibility: visible;
                    opacity: 1;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/map/Tool.vue